const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

export default SET_CURRENT_PAGE;
